<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row>
      <v-col class="py-0">
        <div v-if="model.id" class="mb-3">
          <label class="body-1">Role Name:</label>
          <label class="body-1 ml-2 black--text">{{ model.title }}</label>
        </div>
        <div v-else>
          <anchor-text-field
            id="role-form-name-input"
            required
            label="New Role Name"
            v-model="model.title"
            :rules="rules.name"
          />
        </div>
        <div>
          <label class="body-1">Groups</label>
          <anchor-list-select
            id="role-form-role-select"
            class="mt-2"
            height="400"
            v-model="model.groups"
            :options="allowedGroups"
            :loading="loading"
            :error="error"
          />
        </div>
      </v-col>
    </v-row>
    <div class="d-flex">
      <v-spacer />
      <anchor-form-buttons
        submit-text="save"
        :valid="valid"
        @submit="submit"
        @cancel="() => $emit('cancel')"
      />
    </div>
  </v-form>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import ROLE_MODEL from './resources/model';
import ROLE_RULES from './resources/rules';


export default {
  name: 'AdminRolesForm',
  data: () => ({
    valid: false,
    model: {},
    rules: ROLE_RULES,
    groups: [],
    loading: true,
    error: null,
    originalGroups: [],
  }),
  computed: {
    allowedDomains() {
      return (this.$store.getters.role?.domains || []).map(domain => domain._id);
    },
    allowedGroups() {
      const groups = this.groups.filter(group => this.allowedDomains.includes(group.domain));
      const groupsNames = Array.from(new Set(groups.map(item => item.name)));
      return this.$utils.sortIgnoringCase(groupsNames);
    },
    selectedGroups() {
      if (this.originalGroups.length) {
        const groups = this.groups.filter(group => this.originalGroups.includes(group.name));
        const otherDomainsGroups = groups.filter(group => !this.allowedDomains.includes(group.domain));
        return Array.from(new Set(this.model.groups.concat(otherDomainsGroups.map(g => g.name))));
      }
      return this.model.groups;
    },
  },
  methods: {
    setModel(role) {
      this.$refs.form.reset();
      if (role) {
        const mdl = {};
        Object.keys(ROLE_MODEL).forEach(key => { mdl[key] = role[key]; });
        mdl.id = role._id;
        this.originalGroups = JSON.parse(JSON.stringify(mdl.groups));
        this.model = mdl;
      } else {
        this.model = this.$utils.deepCopy(ROLE_MODEL);
      }
    },
    submit() {
      if (!this.$refs.form.validate()) { return; }

      this.loading = true;
      const method = this.model.id ? 'put' : 'post';
      const url = this.model.id ? `/v1/roles/${this.model.id}` : '/v1/roles';
      const data = this.$utils.deepCopy(this.model);
      data.groups = this.selectedGroups;
      delete data.id;

      this.$requests[method](url, data)
        .then(() => {
          this.$toast.success('Role successfully saved!', { timeout: 3000 });
          this.$emit('success');
        })
        .catch(e => {
          this.$toast.error(e.response.data?.message || 'Unable to save role...', { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
    getGroups() {
      this.loading = true;
      this.$requests.get('/v1/groups?grouped=false')
        .then(response => {
          this.groups = response.data;
          this.$set(this.model, 'groups', this.model.groups.filter(g => this.allowedGroups.includes(g)));
        })
        .catch(() => {
          this.$toast.error('Could not resolve list of groups...', { timeout: 3000 });
          this.error = true;
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getGroups();
  },
};
</script>
